export const formatApplicationNumber = (value) => {
    if (!value)
        return "";
    return value.split("-")[0];
};
//# sourceMappingURL=formatApplicationNumber.js.map